<template>
<div class="login" @click="initExcute(process)">
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      supportAction: {
        ...this.mapSupportAction(['isLogin', 'login', 'logout', 'forceLogin'])
      },
      excutePath: []
    }
  },
  methods: {
    mapSupportAction (actionNames) {
      let actions = {}
      actionNames.forEach(actionName => {
        if (!window.login[actionName]) return

        actions[actionName] = function () {
          return new Promise((resolve, reject) => {
            window.login[actionName](
              res => {
                resolve(res)
              },
              err => {
                reject(err)
              }
            )
          })
        }
      })
      return actions
    },
    checkActionValid (action) {
      if (!this.supportAction[action]) {
        console.error(`Login component: action ${action} unsupport!`)
        return false
      }
      return true
    },
    initExcute () {
      this.excutePath = []
      this.excute(this.process)
    },
    excute (process) {
      if (!process.action) {
        console.error(`Login component: action property required!`)
        return
      }
      if (this.checkActionValid(process.action)) {
        this.supportAction[process.action]()
          .then(res => {
            this.excutePath.push(`${process.action}.success`)
            if (this.process.success) {
              this.excute(this.process.success)
            } else {
              this.$emit('success', res, this.excutePath)
            }
          })
          .catch(rej => {
            this.excutePath.push(`${process.action}.failed`)
            if (this.process.failed) {
              this.excute(this.process.failed)
            } else {
              this.$emit('failed', rej, this.excutePath)
            }
          })
      }
    },
    // 监听登录sdk浮层展示与隐藏的回调
    ObserverCb (mutationsList) {
      for (let mutation in mutationsList) {
        if (mutationsList[mutation].type === 'childList') {
          const addNode = mutationsList[mutation].addedNodes
          const removeNode = mutationsList[mutation].removedNodes

          if (addNode.length > 0) {
            for (let node in addNode) {
              const classNameStr = addNode[node].className || ''
              if (classNameStr.indexOf('login-wrapper') !== -1) {
                document.querySelector('body').style.overflow = 'hidden'
              }
            }
          }
          if (removeNode.length > 0) {
            for (let node in removeNode) {
              const classNameStr = removeNode[node].className || ''
              if (classNameStr.indexOf('login-wrapper') !== -1) {
                document.querySelector('body').style.overflow = 'unset'
              }
            }
          }
        }
      }
    }
  },
  created () {
    // 监听登录sdk浮层dom的add与remove来动态设置一些样式
    const targetNode = document.querySelector('body')
    const config = {
      attributes: false,
      childList: true,
      subtree: false
    }
    const observe = new MutationObserver(this.ObserverCb)
    observe.observe(targetNode, config)
  }
}
</script>

<style lang="stylus" scoped>
</style>